var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"participations"},[_c('span',{staticStyle:{"font-size":"10px","margin-right":"10px"}},[_vm._v("Kontigentstand prüfen")]),_vm._v(" "+_vm._s(150000 - this.totalParticipations)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }